<template>
  <header class="header">
    <img alt="logo" :src="logo" class="header__logo">
    <button class="header__button" @click="logout">Cerrar Sesión</button>
  </header>
</template>
<script>
import {mapState} from "vuex";

export default {
  data() {
    return {
      logoUrl: 'https://fusepongsolutions.s3.us-west-2.amazonaws.com/uploads/company/logo/6/8d8bd488-1e73-4086-bed4-4068de70c0e6.png',
    }
  },
  methods: {
    logout() {
      localStorage.clear();
      window.location.href = '/';
    }
  },
  mounted() {

  },
  computed: {
    logo() {
      return this.getCompany && this.getCompany.attributes.logo.url ? this.getCompany.attributes.logo.url : this.logoUrl;
    }
  }
}
</script>

<style>
.header {
  display: -webkit-flex;
  display: flex;
  width: 100%;
  padding: 1rem;
  height: 5rem;
  box-sizing: border-box;
  background: white;
  border-bottom: 1px solid #b8b8b8;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  box-shadow: 0px 2px 2px #cdcdcd;
}

.header__logo {
  width: auto;
  height: 100%;
}

.header__button {
  border: none;
  background: none;
  font-weight: bold;
  padding: 1rem;
}

.header__button:hover {
  cursor: pointer;
  background: rgb(1 118 251);
  color: white;

}
</style>
